module.exports = __webpack_public_path__ + "static/media/graph_2.1ed2cbbf.png";